/* Short fit copy links to the existing responsive product details accordion. */
(function(win, doc) {
  doc.addEventListener('click', function(event) {
    var link = event.target.closest && event.target.closest('[data-product-details-link]');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var scope = link.closest('[data-section-type="product"]') || doc;
    var productId = link.getAttribute('data-product-details-link');
    function visibleDetails(root) {
      return Array.from(root.querySelectorAll('[data-product-details]')).find(function(details) {
        return details.getAttribute('data-product-details') === productId && details.getClientRects().length && win.getComputedStyle(details).visibility !== 'hidden';
      });
    }
    // Mobile tabs can sit outside the main product section in legacy templates.
    var target = visibleDetails(scope) || visibleDetails(doc);
    var button = target && target.querySelector('[data-action="toggle-collapsible"]');
    if (!button) return;

    event.preventDefault();
    if (button.getAttribute('aria-expanded') !== 'true') button.click();
    function revealDetails() {
      win.requestAnimationFrame(function() {
        button.focus({ preventScroll: true });
        var reducedMotion = win.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var offset = parseFloat(win.getComputedStyle(target).scrollMarginTop) || 0;
        win.scrollTo({ top: Math.max(0, win.scrollY + target.getBoundingClientRect().top - offset), behavior: reducedMotion ? 'instant' : 'smooth' });
      });
    }
    var inner = target.querySelector('.Collapsible__Inner');
    var animations = inner && typeof inner.getAnimations === 'function' ? inner.getAnimations() : [];
    if (animations.length) {
      Promise.all(animations.map(function(animation) { return animation.finished.catch(function() {}); })).then(revealDetails);
    } else {
      revealDetails();
    }
  });
})(window, document);
